import React, { useEffect } from 'react';

export const useScrollMonitor = (
  divRef: React.MutableRefObject<HTMLDivElement | null>,
  setIsStuck: (value: boolean) => void,
  isStuck: boolean | undefined,
  offset: number = 0,
) => {
  useEffect(() => {
    const scrollMonitor = () => {
      if (divRef.current) {
        if (divRef.current.getBoundingClientRect().top < offset) {
          setIsStuck(true);
        } else {
          setIsStuck(false);
        }
      }
    };
    window.addEventListener('resize', scrollMonitor);
    window.addEventListener('scroll', scrollMonitor);

    scrollMonitor();
    return () => {
      window.removeEventListener('resize', scrollMonitor);
      window.removeEventListener('scroll', scrollMonitor);
    };
  }, [isStuck]);
};
